import {
  Breadcrumb,
  DownloadExcel,
  ErrorAlert,
  initDropdowns,
  SearchToggle,
  SmsBalanceAlert,
  Table,
  TableRowsPerPage,
  useEffect,
  useFetchData,
  useSearch,
} from "@";
import { getScheduledMessage } from "./utils/api";
import MultiSearch from "./components/MultiSearch";
import { tableColumns } from "./components/TableOptions";
import { excelHeaderCellsName, searchValues } from "./utils/options";

const Index = () => {
  // Breadcrumb links
  const links = [
    {
      name: "الرسائل المؤتمتة",
      link: "/automated",
    },
    {
      name: "التفاصيل",
      link: "",
    },
  ];

  // Search state and handler
  const { search, updateSearch } = useSearch(searchValues);

  // Fetch data state and handler
  const { data, isLoading, error, pg, fetchData, updatePg } = useFetchData({
    fun: getScheduledMessage,
    params: [search.values],
  });

  // Initialize dropdowns on search toggle
  useEffect(() => {
    initDropdowns();
  }, [search.show]);

  return (
    <>
      {/* Error alert */}
      <ErrorAlert reload={fetchData} show={error} />
      <SmsBalanceAlert />

      <Breadcrumb links={links} />

      <main className="table-card">
        {/* Header */}
        <header className="flex-container">
          {/* Title */}
          <h1 className="page-title"> تفاصيل الرسالة المؤتمتة </h1>

          {/* Options */}
          <div className="options-container">
            <TableRowsPerPage
              pagination={pg}
              onRowsPerPageChange={(size) => updatePg({ size: size })}
            />

            <DownloadExcel
              length={data?.length}
              search={search.values}
              fetch={getScheduledMessage}
              headerCellsName={excelHeaderCellsName}
            />

            <SearchToggle toggle={() => updateSearch({ show: !search.show })} />
          </div>
        </header>

        {/* Multi Search inputs */}
        <MultiSearch
          search={search}
          onSubmit={fetchData}
          updateSearch={updateSearch}
        />

        {/* Table */}
        <Table
          data={data}
          pagination={pg}
          columns={tableColumns}
          isLoading={isLoading}
          pageChange={(page) => updatePg({ page: page })}
          perRowsChange={(size) => updatePg({ size: size })}
        />
      </main>
    </>
  );
};

export default Index;
